import {FEATURED_WORKFLOW_BLOCK_PREFIX} from '@/blocks/featured_workflows/utils';

let defaultWorkflows = [];

// STRATA DEFAULT WORKFLOW
const STRATA_DEFAULT_WORKFLOW_ID = `${FEATURED_WORKFLOW_BLOCK_PREFIX}strata-default`;
const STRATA_DEFAULT_WORKFLOW_XML = `
<xml xmlns="https://developers.google.com/blockly/xml">
    <block type="strata_convergence" id="${STRATA_DEFAULT_WORKFLOW_ID}" x="30" y="30">
        <field name="timeperiod">custom</field>
        <field name="fd">2020-09-10</field>
        <field name="td">2021-09-10</field>
        <field name="area">226</field>
        <statement name="ENV_INDICATORS">
            <block type="strata_env_indicator" id="hNAv=co$0CavIR=UMUt">
                <field name="indicator_selection">agr_dr</field>
                <field name="isCustomThreshold">FALSE</field>
                <next>
                    <block type="strata_env_indicator" id="c)pr/jNgP^ixp[]:DTy3">
                        <field name="indicator_selection">met_dr</field>
                        <field name="isCustomThreshold">FALSE</field>
                        <next>
                            <block type="strata_env_indicator" id="1pWm{J,cm4iupa6Bv{9a">
                                <field name="indicator_selection">heatwave</field>
                                <field name="isCustomThreshold">FALSE</field>
                                <next>
                                    <block type="strata_env_indicator" id="R7_$Cpw3f;AO:FHd($rk">
                                        <field name="indicator_selection">fl_likelihood</field>
                                        <field name="isCustomThreshold">FALSE</field>
                                        <next>
                                            <block type="strata_env_indicator" id="zH94Qu$#rAw6KQ*qFVx">
                                                <field name="indicator_selection">inund_risk</field>
                                                <field name="isCustomThreshold">FALSE</field>
                                                <next>
                                                    <block type="strata_env_indicator" id="^m]NY4M8|2cd6VP}3eiR">
                                                        <field name="indicator_selection">deforestation</field>
                                                        <field name="isCustomThreshold">FALSE</field>
                                                        <next>
                                                            <block type="strata_env_indicator" id="eTbJhaViDlejKs^!!zaT">
                                                                <field name="indicator_selection">degradation</field>
                                                                <field name="isCustomThreshold">FALSE</field>
                                                            </block>
                                                        </next>
                                                    </block>
                                                </next>
                                            </block>
                                        </next>
                                    </block>
                                </next>
                            </block>
                        </next>
                    </block>
                </next>
            </block>
        </statement>
        <statement name="CONFLICT_INDICATORS">
            <block type="strata_conflict_indicator" id="mBR2Uq5ZdTFF2PJFdONk">
                <field name="indicator_selection">conflict_recent_explosions</field>
                <field name="isCustomThreshold">FALSE</field>
                <next>
                    <block type="strata_conflict_indicator" id="[_L5qu$4*l^n|BAZw$!d">
                        <field name="indicator_selection">conflict_recent_violence</field>
                        <field name="isCustomThreshold">FALSE</field>
                        <next>
                            <block type="strata_conflict_indicator" id="$*j+B271bnzSQU(G0Tv]">
                                <field name="indicator_selection">conflict_recent_protests</field>
                                <field name="isCustomThreshold">FALSE</field>
                                <next>
                                    <block type="strata_conflict_indicator" id="bKrY+_1Mcgwdq{49Z+Z">
                                        <field name="indicator_selection">conflict_recent_riots</field>
                                        <field name="isCustomThreshold">FALSE</field>
                                        <next>
                                            <block type="strata_conflict_indicator" id="pLI8{IeVAr#u},XAnKHr">
                                                <field name="indicator_selection">conflict_battles</field>
                                                <field name="isCustomThreshold">FALSE</field>
                                            </block>
                                        </next>
                                    </block>
                                </next>
                            </block>
                        </next>
                    </block>
                </next>
            </block>
        </statement>
        <statement name="VULN_INDICATORS">
            <block type="strata_vuln_indicator" id="Lcw%5#/9?U~Ka#Ccxf!+">
                <field name="indicator_selection">pop_growth</field>
                <field name="isCustomThreshold">FALSE</field>
                <next>
                    <block type="strata_vuln_indicator" id="}]tB=W]/K^:N/y3b.RR5">
                        <field name="indicator_selection">displacement</field>
                        <field name="isCustomThreshold">FALSE</field>
                        <next>
                            <block type="strata_vuln_indicator" id="yR*92)KBhCIFaw!ogEaX">
                                <field name="indicator_selection">time_to_urban</field>
                                <field name="isCustomThreshold">FALSE</field>
                                <next>
                                    <block type="strata_vuln_indicator" id=";v88^le=KE,9=4S[^Q-H">
                                        <field name="indicator_selection">access_electricity</field>
                                        <field name="isCustomThreshold">FALSE</field>
                                        <next>
                                            <block type="strata_vuln_indicator" id="~,qxkvIXR#J4~fGqk-x+">
                                                <field name="indicator_selection">access_healthcare</field>
                                                <field name="isCustomThreshold">FALSE</field>
                                                <next>
                                                    <block type="strata_vuln_indicator" id="yg4%foX^N:R:IN30r!sO">
                                                        <field name="indicator_selection">access_healthcare_walking</field>
                                                        <field name="isCustomThreshold">FALSE</field>
                                                        <next>
                                                            <block type="strata_vuln_indicator" id="R;xi/cKY8-y6}b%aE-Q">
                                                                <field name="indicator_selection">food_insecurity</field>
                                                                <field name="isCustomThreshold">FALSE</field>
                                                                <next>
                                                                    <block type="strata_vuln_indicator" id="pQO..%!5[AoldqaX,zQh">
                                                                        <field name="indicator_selection">urban_expansion</field>
                                                                        <field name="isCustomThreshold">FALSE</field>
                                                                        <next>
                                                                            <block type="strata_vuln_indicator" id="8pm:TfhDS_Qjz(MO(q()">
                                                                                <field name="indicator_selection">irrigation</field>
                                                                                <field name="isCustomThreshold">FALSE</field>
                                                                                <next>
                                                                                    <block type="strata_vuln_indicator" id="|-IhKT2e9kAQI}|ns7l">
                                                                                        <field name="indicator_selection">sanitation</field>
                                                                                        <field name="isCustomThreshold">FALSE</field>
                                                                                    </block>
                                                                                </next>
                                                                            </block>
                                                                        </next>
                                                                    </block>
                                                                </next>
                                                            </block>
                                                        </next>
                                                    </block>
                                                </next>
                                            </block>
                                        </next>
                                    </block>
                                </next>
                            </block>
                        </next>
                    </block>
                </next>
            </block>
        </statement>
        <next>
            <block type="strata_calculate_stress_score" id="PPGbJ)z~7W+Dk_RhD4)p">
                <field name="is_exposure_included">TRUE</field>
                <field name="is_vulnerability_included">TRUE</field>
                <next>
                    <block type="strata_update_dashboard" id="PZpevSCy#3H/2t%F^5.c">
                        <field name="is_vulnerability_included">FALSE</field>
                        <next>
                            <block type="strata_dashboard_viz" id="c1ICX6SEi9W0NYJTU_{z">
                                <field name="charttype">bitmap</field>
                                <next>
                                    <block type="strata_dashboard_viz" id="EMKS/jxHZODaoM/TVE/:">
                                        <field name="charttype">heatmap</field>
                                    </block>
                                </next>
                            </block>
                        </next>
                    </block>
                </next>
            </block>
        </next>
    </block>
</xml>
`;

const STRATA_DEFAULT_WORKFLOW_TITLE = 'Strata 1';
//const STRATA_DEFAULT_WORKFLOW_DESC = `Landsat is the longest running series of Earth observation satellites designed for looking at the land surface.  This workflow displays 3 of the colour measurements made by the most recent Landsat, the 8th in the series, and replicates what a normal photograph would look like.  For Landsat 8, these are the data from the red, green and blue detectors. You can use the drop down menu to choose other detectors, including ones in the infrared part of the spectrum. Surface Reflectance data options means the image is corrected to remove the effects of the atmosphere, and represents the true colour of the surface of the Earth. This example looks at the UK, but you can choose other countries from the drop down menu. `;
//const SIMPLE_OPTICAL_WORKFLOW_IMG = 'Simple-Optical.png';


const STRATA_DEFAULT_WORKFLOW = {
    id: STRATA_DEFAULT_WORKFLOW_ID,
    xml: STRATA_DEFAULT_WORKFLOW_XML,
    title: STRATA_DEFAULT_WORKFLOW_TITLE,
    //desc: STRATA_DEFAULT_WORKFLOW_DESC,
    //img: SIMPLE_OPTICAL_WORKFLOW_IMG,
}

defaultWorkflows.push(STRATA_DEFAULT_WORKFLOW);
// EO --- STRATA DEFAULT WORKFLOW

const STRATA_DEFAULT_WORKFLOW_ID_2 = `${FEATURED_WORKFLOW_BLOCK_PREFIX}strata-default-2`;
const STRATA_DEFAULT_WORKFLOW_XML_2 = `
<xml xmlns="https://developers.google.com/blockly/xml">
    <block type="strata_convergence" id="${STRATA_DEFAULT_WORKFLOW_ID_2}" x="30" y="30">
        <field name="timeperiod">custom</field>
        <field name="fd">2020-09-10</field>
        <field name="td">2021-09-10</field>
        <field name="area">226</field>
        <statement name="ENV_INDICATORS">
            <block type="strata_env_indicator" id="hNAv=co$0CavIR=UMUt">
                <field name="indicator_selection">agr_dr</field>
                <field name="isCustomThreshold">FALSE</field>
                <next>
                    <block type="strata_env_indicator" id="c)pr/jNgP^ixp[]:DTy3">
                        <field name="indicator_selection">met_dr</field>
                        <field name="isCustomThreshold">FALSE</field>
                        <next>
                            <block type="strata_env_indicator" id="1pWm{J,cm4iupa6Bv{9a">
                                <field name="indicator_selection">heatwave</field>
                                <field name="isCustomThreshold">FALSE</field>
                                <next>
                                    <block type="strata_env_indicator" id="R7_$Cpw3f;AO:FHd($rk">
                                        <field name="indicator_selection">fl_likelihood</field>
                                        <field name="isCustomThreshold">FALSE</field>
                                        <next>
                                            <block type="strata_env_indicator" id="zH94Qu$#rAw6KQ*qFVx">
                                                <field name="indicator_selection">inund_risk</field>
                                                <field name="isCustomThreshold">FALSE</field>
                                                <next>
                                                    <block type="strata_env_indicator" id="^m]NY4M8|2cd6VP}3eiR">
                                                        <field name="indicator_selection">deforestation</field>
                                                        <field name="isCustomThreshold">FALSE</field>
                                                        <next>
                                                            <block type="strata_env_indicator" id="eTbJhaViDlejKs^!!zaT">
                                                                <field name="indicator_selection">degradation</field>
                                                                <field name="isCustomThreshold">FALSE</field>
                                                            </block>
                                                        </next>
                                                    </block>
                                                </next>
                                            </block>
                                        </next>
                                    </block>
                                </next>
                            </block>
                        </next>
                    </block>
                </next>
            </block>
        </statement>
        <statement name="CONFLICT_INDICATORS">
            <block type="strata_conflict_indicator" id="mBR2Uq5ZdTFF2PJFdONk">
                <field name="indicator_selection">conflict_recent_explosions</field>
                <field name="isCustomThreshold">FALSE</field>
                <next>
                    <block type="strata_conflict_indicator" id="[_L5qu$4*l^n|BAZw$!d">
                        <field name="indicator_selection">conflict_recent_violence</field>
                        <field name="isCustomThreshold">FALSE</field>
                        <next>
                            <block type="strata_conflict_indicator" id="$*j+B271bnzSQU(G0Tv]">
                                <field name="indicator_selection">conflict_recent_protests</field>
                                <field name="isCustomThreshold">FALSE</field>
                                <next>
                                    <block type="strata_conflict_indicator" id="bKrY+_1Mcgwdq{49Z+Z">
                                        <field name="indicator_selection">conflict_recent_riots</field>
                                        <field name="isCustomThreshold">FALSE</field>
                                        <next>
                                            <block type="strata_conflict_indicator" id="pLI8{IeVAr#u},XAnKHr">
                                                <field name="indicator_selection">conflict_battles</field>
                                                <field name="isCustomThreshold">FALSE</field>
                                            </block>
                                        </next>
                                    </block>
                                </next>
                            </block>
                        </next>
                    </block>
                </next>
            </block>
        </statement>
        <statement name="VULN_INDICATORS">
            <block type="strata_vuln_indicator" id="Lcw%5#/9?U~Ka#Ccxf!+">
                <field name="indicator_selection">pop_growth</field>
                <field name="isCustomThreshold">FALSE</field>
                <next>
                    <block type="strata_vuln_indicator" id="}]tB=W]/K^:N/y3b.RR5">
                        <field name="indicator_selection">displacement</field>
                        <field name="isCustomThreshold">FALSE</field>
                        <next>
                            <block type="strata_vuln_indicator" id="yR*92)KBhCIFaw!ogEaX">
                                <field name="indicator_selection">time_to_urban</field>
                                <field name="isCustomThreshold">FALSE</field>
                                <next>
                                    <block type="strata_vuln_indicator" id=";v88^le=KE,9=4S[^Q-H">
                                        <field name="indicator_selection">access_electricity</field>
                                        <field name="isCustomThreshold">FALSE</field>
                                        <next>
                                            <block type="strata_vuln_indicator" id="~,qxkvIXR#J4~fGqk-x+">
                                                <field name="indicator_selection">access_healthcare</field>
                                                <field name="isCustomThreshold">FALSE</field>
                                                <next>
                                                    <block type="strata_vuln_indicator" id="yg4%foX^N:R:IN30r!sO">
                                                        <field name="indicator_selection">access_healthcare_walking</field>
                                                        <field name="isCustomThreshold">FALSE</field>
                                                        <next>
                                                            <block type="strata_vuln_indicator" id="R;xi/cKY8-y6}b%aE-Q">
                                                                <field name="indicator_selection">food_insecurity</field>
                                                                <field name="isCustomThreshold">FALSE</field>
                                                                <next>
                                                                    <block type="strata_vuln_indicator" id="pQO..%!5[AoldqaX,zQh">
                                                                        <field name="indicator_selection">urban_expansion</field>
                                                                        <field name="isCustomThreshold">FALSE</field>
                                                                        <next>
                                                                            <block type="strata_vuln_indicator" id="8pm:TfhDS_Qjz(MO(q()">
                                                                                <field name="indicator_selection">irrigation</field>
                                                                                <field name="isCustomThreshold">FALSE</field>
                                                                                <next>
                                                                                    <block type="strata_vuln_indicator" id="|-IhKT2e9kAQI}|ns7l">
                                                                                        <field name="indicator_selection">sanitation</field>
                                                                                        <field name="isCustomThreshold">FALSE</field>
                                                                                    </block>
                                                                                </next>
                                                                            </block>
                                                                        </next>
                                                                    </block>
                                                                </next>
                                                            </block>
                                                        </next>
                                                    </block>
                                                </next>
                                            </block>
                                        </next>
                                    </block>
                                </next>
                            </block>
                        </next>
                    </block>
                </next>
            </block>
        </statement>
        <next>
            <block type="strata_calculate_stress_score" id="PPGbJ)z~7W+Dk_RhD4)p">
                <field name="is_exposure_included">TRUE</field>
                <field name="is_vulnerability_included">TRUE</field>
                <next>
                    <block type="strata_update_dashboard" id="PZpevSCy#3H/2t%F^5.c">
                        <field name="is_vulnerability_included">FALSE</field>
                        <next>
                            <block type="strata_dashboard_viz" id="c1ICX6SEi9W0NYJTU_{z">
                                <field name="charttype">bitmap</field>
                                <next>
                                    <block type="strata_dashboard_viz" id="EMKS/jxHZODaoM/TVE/:">
                                        <field name="charttype">heatmap</field>
                                    </block>
                                </next>
                            </block>
                        </next>
                    </block>
                </next>
            </block>
        </next>
    </block>
</xml>
`;

const STRATA_DEFAULT_WORKFLOW_TITLE2 = 'Strata 2';
//const STRATA_DEFAULT_WORKFLOW_DESC2 = `Landsat is the longest running series of Earth observation satellites designed for looking at the land surface.  This workflow displays 3 of the colour measurements made by the most recent Landsat, the 8th in the series, and replicates what a normal photograph would look like.  For Landsat 8, these are the data from the red, green and blue detectors. You can use the drop down menu to choose other detectors, including ones in the infrared part of the spectrum. Surface Reflectance data options means the image is corrected to remove the effects of the atmosphere, and represents the true colour of the surface of the Earth. This example looks at the UK, but you can choose other countries from the drop down menu. `;
//const SIMPLE_OPTICAL_WORKFLOW_IMG2 = 'Simple-Optical.png';


const STRATA_DEFAULT_WORKFLOW_2 = {
    id: STRATA_DEFAULT_WORKFLOW_ID_2,
    xml: STRATA_DEFAULT_WORKFLOW_XML_2,
    title: STRATA_DEFAULT_WORKFLOW_TITLE2,
    //desc: STRATA_DEFAULT_WORKFLOW_DESC2,
    //img: SIMPLE_OPTICAL_WORKFLOW_IMG2 ,
}

defaultWorkflows.push(STRATA_DEFAULT_WORKFLOW_2);

export { defaultWorkflows }